package com.dotdrives.client

import com.dotdrives.model.*
import com.dotdrives.model.Target
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.from
import io.github.jan.supabase.postgrest.query.Order
import kotlinx.serialization.json.*

class ConfigurationClient(private val client: SupabaseClient = SupabaseProvider.client) {
    suspend fun load(org: String, targetsOnly: Boolean = false) =
        ConfigurationSnapshot(
            fetchAllPages(1000L) { offset ->
                client
                    .from("targets")
                    .select {
                        range(offset, offset + 999)
                        filter { eq("org_id", org) }
                        order("name", Order.ASCENDING)
                        order("id", Order.ASCENDING)
                    }
                    .decodeList<Target>()
            },
            if (targetsOnly) emptyList() else fetchAllPages(1000L) { offset ->
                client
                    .from("drive_phase_templates")
                    .select {
                        range(offset, offset + 999)
                        filter { eq("org_id", org) }
                        order("name", Order.ASCENDING)
                        order("id", Order.ASCENDING)
                    }
                    .decodeList<DrivePhaseTemplate>()
            },
            if (targetsOnly) emptyList() else fetchAllPages(1000L) { offset ->
                client
                    .from("drive_phases")
                    .select {
                        range(offset, offset + 999)
                        filter { eq("org_id", org) }
                        order("sequence", Order.ASCENDING)
                        order("id", Order.ASCENDING)
                    }
                    .decodeList<DrivePhase>()
            },
        )

    suspend fun target(value: Target) {
        client
            .from("targets")
            .upsert(
                buildJsonObject {
                    put("id", value.id)
                    put("org_id", value.orgId)
                    put("name", value.name)
                    put("goal_amount", value.goalAmount)
                    put("is_active", value.isActive)
                    put("goal_starts_on", value.goalStartsOn)
                    put("goal_ends_on", value.goalEndsOn)
                }
            )
    }

    suspend fun phase(value: DrivePhase) {
        client
            .from("drive_phases")
            .upsert(
                buildJsonObject {
                    put("id", value.id)
                    put("org_id", value.orgId)
                    put("template_id", value.templateId)
                    put("name", value.name)
                    put("description", value.description)
                    put("example_text", value.exampleText)
                    put("sequence", value.sequence)
                    put("is_terminal", value.isTerminal)
                }
            )
    }

    suspend fun template(value: DrivePhaseTemplate) {
        client.from("drive_phase_templates").upsert(value)
    }
}
